<template>
<div v-if='$store.state.res.loading'>
    <div class="block-div"></div>
    <div class="loading-box">
        <img src="/static/images/site/loading-square.gif" alt="">
    </div>
</div>
</template>

<script>
export default {
}
</script>

<style scoped>
    .block-div
    {
        width:100%;
        height:100%;
        cursor:wait;
        background-color:rgba(0,0,0,0);
        position:fixed;
        top:0;
        left:0;
        /*- blockUI的z-index统一设置为2000 -*/
        z-index:2000;
    }
    .loading-box{
        width: 130px;
        height: 70px;
        position: fixed;
        top: 50%;
        left: 50%;
        margin: -35px 0 0 -75px;
        z-index: 3000;
        /*
        border-radius: 50%;
        box-shadow: -10px 0 10px 0px rgba(0, 0, 0, 0.15), 
        0 -10px 10px 0px rgba(0, 0, 0, 0.15), 
        0 10px 10px 0px rgba(0, 0, 0, 0.15), 
        10px 0 10px 0px rgba(0, 0, 0, 0.15);
        */
    }
    .loading-box img {
        /* border-radius: 50%;
        background-color:#fff; */
    }
</style>



// WEBPACK FOOTER //
// src/components/common/site/Loading.vue